export { globalizationQueries } from './globalization-queries';
